import { useMutation, useQuery } from '@tanstack/react-query';
import * as api from 'api/campaign';
import { useCampaignId } from './useCampaignId';

const POLLING_INTERVAL = 1000;

export const useCampaignTargetingGeneration = (enabled: boolean) => {
  const campaignId = useCampaignId();

  const getCampaignTargetingSuggestions = useQuery({
    queryKey: ['campaignTargetingSuggestions'],
    queryFn: () => api.fetchTargetingSuggestions(campaignId as number),
    enabled: !!campaignId && enabled,
    refetchInterval: enabled ? POLLING_INTERVAL : undefined,
    refetchIntervalInBackground: enabled,
  });

  const generateCampaignTargetingSuggestions = useMutation({
    mutationFn: (websiteUrl: string) => api.generateTargetingSuggestions(campaignId as number, websiteUrl),
    onSuccess: () => {
      getCampaignTargetingSuggestions.refetch();
    },
  });

  return {
    getCampaignTargetingSuggestions,
    generateCampaignTargetingSuggestions,
  };
};
